import React from 'react';
import { MapPin, Phone, ExternalLink } from 'lucide-react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="app-footer">
      <div className="footer-content">
        <div className="footer-section">
          <h4>Hotel The Container</h4>
          <p>Industrial charm meets modern comfort</p>
          <div className="footer-location">
            <a 
              href="https://maps.app.goo.gl/UbarUB5SMs8bFLeE8" 
              target="_blank" 
              rel="noopener noreferrer"
              className="footer-location-link"
            >
              <MapPin size={16} />
              Kolhapur, Maharashtra
              <ExternalLink size={12} />
            </a>
          </div>
        </div>
        
        <div className="footer-section">
          <h4>Quick Links</h4>
          <div className="footer-links">
            <a href="/">Home</a>
            <a href="/rooms">Rooms</a>
            <a href="/gallery">Gallery</a>
          </div>
        </div>
        
        <div className="footer-section">
          <h4>Contact us</h4>
          <div className="footer-contact">
            <a href="tel:7796775959" className="footer-phone">
              <Phone size={16} />
              7796775959
            </a>
          </div>
        </div>
        
        <div className="footer-section">
          <h4>Developed By</h4>
          <p><strong>Robotech AI Technologies</strong></p>
          <p>Contact: <a href="tel:9960810617" style={{ color: 'white' }}>9960810617</a></p>
        </div>
      </div>
      
      <div className="footer-bottom">
        <p>&copy; 2025 Hotel The Container. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
